(function(){
  var key='gc_waitlist_pending_v1',sentKey='gc_waitlist_sent_v1',privacy,attempted=false;
  function read(keyName){try{return JSON.parse(sessionStorage.getItem(keyName)||'null');}catch(error){return null;}}
  function remove(keyName){try{sessionStorage.removeItem(keyName);}catch(error){}}
  function allowed(){return !!(privacy&&privacy.currentVisitorConsent().analytics==='yes'&&privacy.analyticsProcessingAllowed());}
  function confirm(){
    if(attempted||!document.querySelector('[data-waitlist-success]'))return;
    var pending=read(key);
    if(!pending)return;
    if(Date.now()-pending.time>1200000||pending.path!==location.pathname){remove(key);return;}
    if(!privacy)return;
    if(!allowed()){remove(key);return;}
    if(!(window.Shopify.analytics&&typeof window.Shopify.analytics.publish==='function'))return;
    if(read(sentKey)===pending.id){remove(key);return;}
    attempted=true;
    try{
      sessionStorage.setItem(sentKey,JSON.stringify(pending.id));
      remove(key);
      window.Shopify.analytics.publish('genicalc:waitlist_joined',{
        form_id:pending.form,
        signup_country:pending.country,
        debug_mode:pending.debug
      });
      document.querySelector('[data-waitlist-success]').dataset.leadPublished='true';
    }catch(error){attempted=false;}
  }
  document.addEventListener('submit',function(event){
    var form=event.target;
    if(!form.classList||!form.classList.contains('waitlist-form')||event.defaultPrevented||!form.checkValidity())return;
    if(!allowed()){remove(key);return;}
    var country=form.querySelector('[data-waitlist-country]'),destination=form.querySelector('[name="return_to"]');
    var returnPath=location.pathname;
    if(destination){try{returnPath=new URL(destination.value,location.origin).pathname;}catch(error){}}
    try{
      sessionStorage.setItem(key,JSON.stringify({
        id:Date.now().toString(36)+'-'+Math.random().toString(36).slice(2),
        time:Date.now(),path:returnPath,form:form.id||'waitlist',
        country:country&&/^[A-Z]{2}$/.test(country.value)?country.value:'XX',
        debug:new URLSearchParams(location.search).get('gc_debug')==='1'
      }));
    }catch(error){}
  },true);
  function ready(error){if(error||!(window.Shopify&&window.Shopify.customerPrivacy))return;privacy=window.Shopify.customerPrivacy;confirm();}
  document.addEventListener('visitorConsentCollected',function(){if(privacy)confirm();});
  if(window.Shopify&&window.Shopify.customerPrivacy){ready();}
  else if(window.Shopify&&window.Shopify.loadFeatures){window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],ready);}
  window.addEventListener('load',confirm,{once:true});
})();

